<template>
    <label>Phone Number</label>
    <div class="input-group mb-3">
        <input type="tel" class="form-control"></input>
        <select style="max-width: 120px; border-left: none;" class="form-control input-group-append" @change="onCountryChange">
            <option v-for="country in countries" :key="country.code" :value="country.code"
                class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2 px-3">
                {{ country.flag }} {{ country.code }} (+{{ country.dialCode }})
            </option>
        </select>
    </div>
</template>

<script>
import { COUNTRIES } from '../../../helpers/data/address-data-provider';

export default {
    name: 'PhoneInput',
    props: {
        countryCode: 'AU'
    },
    data() {
        return {
            countries: COUNTRIES,
            selectedCountry: COUNTRIES.find(c => c.code === this.countryCode) || COUNTRIES[0]
        }
    },
    computed: {},
    methods: {
        selectCountry(country) {
            this.selectedCountry = country;
            console.log(this.selectCountry);
            this.phoneCountryDropdownOpen = false;
        },
    }
}

</script>